<div>
  @switch (currentSlide()) {
    @case (0) {
      <ion-grid
        class="ion-no-padding"
        col-12
        [formGroup]="form"
        [ngClass]="{ submitted: isFormSubmitted() }"
      >
        <ion-row>
          <ion-col
            size-xs="12"
            size-md="12"
            size-lg="12"
            class="ion-text-center ion-justify-content-center"
          >
            <ion-label class="panel-header-text" color="dark">
              {{ 'forgotPassword_introTitle' | translate }}
            </ion-label>
          </ion-col>
        </ion-row>
        <ion-row class="ion-padding-bottom ion-margin-bottom">
          <ion-col
            class="ion-margin-top ion-text-center ion-justify-content-center"
            size-xs="8"
            size-md="8"
            size-lg="8"
            offset="2"
          >
            <ion-label color="dark">
              {{ 'forgotPassword_introText' | translate }}
            </ion-label>
          </ion-col>
        </ion-row>
        <ion-row class="ion-padding-top ion-margin-top">
          <ion-col size="8" offset="2">
            <ion-label class="ion-float-left pb-05">{{
              'forgotPassword_step1' | translate
            }}</ion-label>
            <ion-input
              type="text"
              class="ion-text-left"
              placeholder="{{ 'forgotPassword_email' | translate }}"
              formControlName="email"
            >
            </ion-input>

            <ng-container>
              <ion-button
                type="submit"
                class="ion-float-right"
                color="primary"
                (click)="submitEmail()"
              >
                <small>{{ 'forgotPassword_next' | translate }}</small>
              </ion-button>
            </ng-container>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col
            size="8"
            offset="2"
            class="text-center ion-justify-content-between"
          >
            <a (click)="gotoLogin()" class="font-size-12 cursor-pointer">{{
              'forgotPassword_toLogin' | translate
            }}</a>
          </ion-col>
        </ion-row>
      </ion-grid>
    }
    @case (1) {
      <ion-grid class="ion-no-padding" col-12>
        <ion-row>
          <ion-col
            size="8"
            offset="2"
            class="text-center ion-justify-content-between"
          >
            <p>{{ 'forgotPassword_pending' | translate }}</p>
          </ion-col>
        </ion-row>
        <ion-row class="mt-1 mb-1">
          <ion-col
            size="8"
            offset="2"
            class="text-center ion-justify-content-center"
          >
            <ion-spinner></ion-spinner>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col
            size="8"
            offset="2"
            class="text-center ion-justify-content-between"
          >
            <a (click)="gotoLogin()" class="font-size-12 cursor-pointer">{{
              'forgotPassword_toLogin' | translate
            }}</a>
          </ion-col>
        </ion-row>
      </ion-grid>
    }
    @case (2) {
      <ion-grid class="ion-no-padding" size="12">
        <ion-row>
          <ion-col
            size="8"
            offset="2"
            class="text-center ion-justify-content-between"
          >
            <p>{{ 'forgotPassword_succeeded' | translate }}</p>
            <p>{{ 'forgotPassword_succeededInfo' | translate }}</p>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col
            size="8"
            offset="2"
            class="text-center ion-justify-content-between"
          >
            <a (click)="gotoLogin()" class="font-size-12 cursor-pointer">{{
              'forgotPassword_toLogin' | translate
            }}</a>
          </ion-col>
        </ion-row>
      </ion-grid>
    }
    @case (3) {
      <ion-grid class="ion-padding-top ion-margin-top" size="12">
        <ion-row>
          <ion-col
            size="8"
            offset="2"
            class="text-center ion-justify-content-between"
          >
            <p>{{ 'forgotPassword_failed' | translate }}</p>
            <p>{{ 'forgotPassword_failedInfo' | translate }}</p>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col
            size="8"
            offset="2"
            class="text-center ion-justify-content-between"
          >
            <a (click)="gotoLogin()" class="font-size-12 cursor-pointer">{{
              'forgotPassword_toLogin' | translate
            }}</a>
          </ion-col>
        </ion-row>
      </ion-grid>
    }
  }
</div>
